export enum ProjectType {
  cmsDays = 0,
  tickets = 1,
}
